import { render, staticRenderFns } from "./Episodes.vue?vue&type=template&id=dfbd17c6&scoped=true&"
import script from "./Episodes.vue?vue&type=script&lang=js&"
export * from "./Episodes.vue?vue&type=script&lang=js&"
import style0 from "./Episodes.vue?vue&type=style&index=0&id=dfbd17c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbd17c6",
  null
  
)

export default component.exports